<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Carole and her husband spent 35 years sailing the world, visiting one hundred and thirty-five countries. She has forgotten how many ports of call they made as it must be in the hundreds. They have settled in Queensland, Australia, and are enjoying life in a beachside town on the east coast of Australia. For their retirement they have a one-acre property near their four children. Her writing every day is her greatest pleasure.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5f8255ec